export default {
  Title_Common: {
    System_Platform: '系统平台',
    TiShi: '提示',
    DianZiCheng_SheDing: '电子秤设定',
    YaoPingZhongLiang: '药品重量',
    KaiShiZhi: '开始值',
    JieShuZhi: '结束值',
    WuCha: '误差',
    AnZhaoBiLiJiSuan: '按照比例计算',
    NONG_S_System: '农本方中医诊所管理系统',
    Guige_Biaozhun: '规格标准',
    Gonggong_Shuju: '公共数据',
    Zidian_Guanli: '字典管理',
    ZhenJiu_FanFa: '针灸方法',
    ZhenJiu_WeiZhi: '针灸位置',
    YaoPing_GongNeng: '药品功能',
    YaoPing_PingPai: '药品品牌',
    ZhiFu_FangShi: '支付方式',
    HuiYuan_LeiBie: '会员类别',
    HuaYan_LeiXing: '化验类型',
    XinZeng_ZiDian: '新增{name}',
    XiuGai_ZiDian: '修改{name}',
    HaoYuan_GuiZe: '号源规则',
    GuanLi_XiTong: '管理系统',
    ShouYe: '首页',
    ZhenSuo_GuanLi: '诊所管理',
    YuanGong_GuanLi: '员工管理',
    XinZeng_YuanGong_XinXi: '新增员工信息',
    XiuGai_YuanGong_XinXi: '修改员工信息',
    YuanGong_XinXi: '员工信息',
    YuanGong_ChuShi_Hua: '员工初始化',
    QueRen_ChongZhi_MiMa: '确认重置密码',
    JueSe_QuanXian: '角色权限',
    ZhenSuo_PeiZhi: '诊所配置',
    YouHuiQuan: '优惠券',
    YongHu_GuanLi: '用户管理',
    HuanZhe_GuanLi: '患者管理',
    BiaoQian_LieBiao: '标签列表',
    ZhuanJieMa: '转介码',
    YaoPin_GuanLi: '药品管理',
    YaoPin_LieBiao: '药品列表',
    CaiGou_PanDian: '采购盘点',
    YaoPin_CaiGou: '药品采购',
    YaoPin_PanDian: '药品盘点',
    YaoPin_TiaoZheng: '药品调整',
    XiangMu_GuanLi: '项目管理',
    ZhenJiu_GuanLi: '针灸管理',
    TuiNa_ZhengGu: '推拿/正骨',
    BaGuan_GuanLi: '拔罐管理',
    PiPei_YaoWu: '匹配药物',
    ShangDian_LingShou: '商店零售',
    TaoPiao_GuanLi: '套票管理',
    ShangPin_GuanLi: '商品管理',
    ChaXun_TongJi: '查询统计',
    KeYuan_YingShou: '客源营收',
    YaoPin_ShiYong_ChengBen_BaoGao: '药品使用成本报告',
    DuiZhang_Dan: '对账单',
    DanJu_MingXi_WangJiao: '单据明细(旺角)',
    ZhongYi_ZhenSuo: '中医诊所',
    Zhong: '中',
    ZhenSuo_Duan: '诊所端',
    GuanLi_Duan: '管理端',
    PeiSong_SheDing: '配送设定',
    ZhiFu_SheDing: '支付设定',
    PeiYao_SheDing: '配药设定',
    YongHu_XinXi: '用户信息',
    XinZeng_YouHuiQuan_XinXi: '新增优惠券信息',
    XiuGai_YouHuiQuan_XinXi: '修改优惠券信息',
    YouHuiQuan_XinXi: '优惠券信息',
    QueRen_QiYong: '确认启用',
    QueRen_TingYong: '确认停用',
    BingRen_ZiLiao: '病人资料',
    XinZeng_BingRen_ZiLiao: '新增病人资料',
    BianJi_BingRen_ZiLiao: '编辑病人资料',
    ZhengZai_ShanChu_YongHu: '正在删除用户',
    TaoCan_GuanLi: '套餐管理',
    XinZeng_TaoCan: '新增套餐',
    ZhenSuo_SheDing: '诊所设定',
    PeiSong_DiZhi: '配送地址',
    TianJia_ShouHuo_DiZhi: '添加收货地址',
    BianJi_ShouHuo_DiZhi: '编辑收货地址',
    YaoPin_MingXi: '药品明细',
    DingDan_XiangQing: '订单详情',
    QianShou_YaoPin: '签收药品',
    DingDan_ShenHe: '订单审核',
    CaiGou_DingDan: '采购订单',
    DingDan_QianShou: '订单签收',
    YaoPin_XuanZe: '药品选择',
    KuCun_TiaoZheng: '库存调整',
    ChuZhi_Ka: '储值卡',
    YouHui_GuanLi: '优惠管理',
    XinZeng_ChuZhiKa_XinXi: '新增储值卡信息',
    BianJi_ChuZhiKa_XinXi: '编辑储值卡信息',
    ChuZhiKa_XinXi: '储值卡信息',
    QianMing: '签名',
    PanDian_XiangQing: '盘点详情',
    TiaoZheng_XiangQing: '调整详情',
    PanDian_YuLan: '盘点预览',
    XiTong_ShouYe: '系统首页',
    ZhiFu_SheZhi: '支付设置',
    PeiYao_SheZhi: '配药设置',
    ShouFei_SheZhi: '收费设置',
    ShouFei_XiangMu: '收费项目',
    DaYin: '打印',
    DaYin_SheZhi: '打印设置',
    ShouFei_Zu: '收费组',
    ChuZhi_HuoDong: '储值活动',
    XinZeng_ChuZhi_HuoDong: '新增储值活动',
    BianJi_ChuZhi_HuoDong: '编辑储值活动',
    HuoDong_XinXi: '活动信息',
    ChuZhi_YongHu: '储值用户',
    ChangYong_SheDing: '常用设定',
    ChangYong_ChuFang: '常用处方',
    ChangYong_XueWei: '常用穴位',
    ChangYong_FenLei: '常用分类',
    FenLei_ChuFang_Dan: '分类处方单',
    ChuFang_Dan_NeiRong: '处方单内容',
    FenLei_XueWei_Dan: '分类穴位单',
    XueWei_Dan_NeiRong: '穴位单内容',
    BianHao_SheZhi: '编号设置',
    XinZeng_XiangMu: '新增项目',
    XiuGai_XiangMu: '修改项目',
    XinZeng_TaoPiao_XinXi: '新增套票信息',
    XiuGai_TaoPiao_XinXi: '修改套票信息',
    TaoPiao_XinXi: '套票信息',
    ZhenZhi_SheZhi: '诊治设置',
    ZhenDuan_ZiLiao_SheDing: '诊断资料设定',
    DaYin_JiLu: '打印记录',
    RiZhi: '日志',
    DaYin_RiZhi: '打印日志',
    DengLu_RiZhi: '登录日志',
    PaiBan_SheZhi: '排班设置',
    DiTu: '地图',
    JiGou_GuanLi: '机构管理',
    RenYuan_GuanLi: '人员管理',
    ShouQuan_GuanLi: '授权管理',
    XiTong_GuanLi: '系统管理',
    JieXi_GuanLi: '解析管理',
    XiaoXi_TongZhi: '消息通知',
    TuiSong_MuBan: '推送模板',
    DiSanFang: '第三方',
    MiYao_GuanLi: '秘钥管理',
    XinZeng_MiYao: '新增秘钥',
    XiuGai_MiYao: '修改秘钥',
    YiShi_MingDan: '医师名单',
    XinZeng_YaoPin_GuiGe: '新增药品规格',
    XiuGai_YaoPin_GuiGe: '修改药品规格',
    YaoPin_PiCi: '药品批次',
    XinZeng_YaoPin_PiCi: '新增药品批次',
    XiuGai_YaoPin_PiCi: '修改药品批次',
    ZhenSuo_LieBiao: '诊所列表',
    XuanZe_YonHu: '选择用户',
    DiTu_SouXun: '地图搜寻',
    DaBao_SheDing: '打包设定',
    JianGe_PeiZhi: '间隔配置',
    PaiBan_GuiZe: '排班规则',
    GuiShu: '归属',
    HaoYuan_SheZhi: '号源设置',
    HaoYuan_SheDing: '诊症号源',
    YiShi_PaiBan: '医师排班',
    HaoYuan_PaiBan: '号源排班',
    LuYou_GuanLi: '路由管理',
    XinZeng_LuYou: '新增路由',
    XiuGai_LuYou: '修改路由',
    MoKuai_QuanXian: '模块权限',
    GongNeng_QuanXian: '功能权限',
    QuanXian: '权限',
    HuanZhe_LiBiao: '患者列表',
    YaoPin_KuCun: '药品库存',
    XinZeng_YaoPin_KuCun: '新增药品库存',
    XiuGai_YaoPin_KuCun: '修改药品库存',
    YingShou_GuanLi: '营收管理',
    ShouFei_SheDing: '收费设定',
    ChuZhi_XinXi: '储值信息',
    XinZeng_PiPei_YaoWu: '新增匹配药物',
    XiuGai_PiPei_YaoWu: '修改匹配药物',
    ZhenSuo_LingShou: '零售管理',
    YaoPin_LingShou: '药品零售',
    XinZeng_ShangPin: '新增商品',
    XiuGai_ShangPin: '修改商品',
    ShangPin_XinXi: '商品信息',
    LingShou_HuoDong: '零售活动',
    XinZeng_LingShou_HuoDong: '新增零售活动',
    XiuGai_LingShou_HuoDong: '修改零售活动',
    XinZeng_PiCi: '新增批次',
    XiuGai_PiCi: '修改批次',
    Yaopin_MuBan: '药品模板',
    JinJi_MuBan: '禁忌模板',
    YaoWu_HuChi: '配伍禁忌',
    MinGan_JinJi: '敏感禁忌',
    ZuZhi_GuanLi: '组织管理',
    KuCun_ZhuiZong: '库存追踪',
    HuaYan_ZhiBiao: '化验指标',
    HeBing_HuanZhe: '合并患者',
  },
}
